import { useLocation } from "react-router-dom";

/**
 * It returns a new URLSearchParams object that contains the query string of the current URL.
 * @returns A new instance of URLSearchParams.
 */
const useQuery = () => {
  const location = useLocation();
  return new URLSearchParams(location.search);
};

export default useQuery;
